import { createReducer, createAction } from '@reduxjs/toolkit';
import type { ListState, ListItem } from './types';

// Re-export types for consumers
export type { ListState, ListItem, ListSelectOption, ListItemType } from './types';

const initState: ListState = {
  data: [
    {
      id: 1,
      title: 'Text input',
      value: '15171',
      type: 'input',
      display: true,
    },
    {
      id: 2,
      title: 'Number input',
      value: '10052536',
      type: 'number',
      display: true,
    },
    {
      id: 3,
      title: 'Select',
      value: 'Shaft vertical cylinder 1',
      values: [
        { label: 'Shaft vertical cylinder 1', value: 'Shaft vertical cylinder 1' },
        { label: 'Shaft vertical cylinder 2', value: 'Shaft vertical cylinder 2' },
        { label: 'Shaft vertical cylinder 3', value: 'Shaft vertical cylinder 3' },
      ],
      type: 'select',
      display: true,
    },
    {
      id: 4,
      title: 'Date',
      value: new Date(1598051730000),
      type: 'date',
      display: true,
    },
    {
      id: 5,
      title: 'Time',
      value: new Date(1598051730000),
      type: 'time',
      display: true,
    },
    {
      id: 6,
      title: 'Calculatie',
      value: '15171',
      edditable: true,
      type: 'input',
      display: true,
    },
    {
      id: 7,
      title: 'In productie',
      value: '1000',
      edditable: true,
      type: 'input',
      display: true,
    },
    {
      id: 8,
      title: 'In bestelling',
      value: '1500',
      edditable: true,
      type: 'input',
      display: true,
    },
    {
      id: 9,
      title: 'Plankvoorraad',
      value: '500',
      edditable: true,
      type: 'input',
      display: true,
    },
    {
      id: 10,
      title: 'Locatie',
      value: 'PB9-43',
      display: true,
    },
    {
      id: 11,
      title: 'Locatie',
      value: 'PB9-43',
      display: true,
    },
    {
      id: 12,
      title: 'Locatie',
      value: 'PB9-43',
      display: true,
    },
    {
      id: 13,
      title: 'Locatie',
      value: 'PB9-43',
      display: true,
    },
    {
      id: 14,
      title: 'Locatie',
      value: 'PB9-43',
      display: true,
    },
    {
      id: 15,
      title: 'Locatie',
      value: 'PB9-43',
      display: true,
    },
    {
      id: 16,
      title: 'Locatie',
      value: 'PB9-43',
      display: true,
    },
    {
      id: 17,
      title: 'Locatie',
      value: 'PB9-43',
      display: true,
    },
  ],
};

export const updateList = createAction<ListItem[]>('list/updateList');
export const clearList = createAction('list/clearist');

export const clear = createAction('clear');

export default createReducer<ListState>(initState, (builder) => {
  builder
    .addCase(updateList, (state, action) => ({
      ...state,
      data: action.payload,
    }))
    .addCase(clearList, () => ({
      ...initState,
      data: [],
    }))
    .addCase(clear, () => {
      return initState;
    });
});
